import { AxiosError } from "axios";
import { camelize } from "humps";

/**
 * Rails renders failed validations as `{ attribute: [message, ...] }` with a
 * 422 status. Unlike successful responses, error bodies do not go through the
 * camelizing response interceptor, so attribute names arrive snake_cased.
 */
export type ApiValidationErrors = Record<string, string[]>;

export const isValidationError = (
	error: unknown,
): error is AxiosError<ApiValidationErrors> =>
	error instanceof AxiosError && error.response?.status === 422;

/** Maps a 422 body to `{ camelCasedField: 'joined messages' }`. */
export const validationErrors = (error: unknown): Record<string, string> => {
	if (!isValidationError(error) || !error.response?.data) {
		return {};
	}

	return Object.entries(error.response.data).reduce<Record<string, string>>(
		(acc, [attribute, messages]) => {
			const message = Array.isArray(messages)
				? messages.join(", ")
				: typeof messages === "string"
					? messages
					: undefined;

			if (message) {
				acc[camelize(attribute)] = message;
			}

			return acc;
		},
		{},
	);
};
